import { useState } from "react";
import assets from "../../assets";
import "./styles.sass";
import {
  TNPSC_NAV_ICONS,
  updateNavItemsBySubscription,
} from "../../utils/constant";
import { useNavigate, useLocation } from "react-router-dom";
import {
  COOKIE_ACCESS_BOARD,
  COOKIE_ACCESS_EXAM,
  COOKIE_ACCESS_MAIL,
  COOKIE_ACCESS_ROLE,
  COOKIE_ACCESS_SUBSCRIBED_COURSES,
} from "../../utils/storage-constants";
import { useSingleton } from "../../hooks/use-singleton";
import { useAuth } from "../../hooks/use-auth";
import { LogoutPopup } from "../logout-popup";
import { ROUTE_PROFILE } from "../../route/tnpscRoute";

export const BaseContainer = ({ children }) => {
  const navigate = useNavigate();
  const {
    updateMail,
    updateBoard,
    updateRole,
    updateExam,
    user,
    mail,
    role,
    examType,
  } = useSingleton();
  const [show, setShow] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const location = useLocation();
  const subscribedCourses = JSON.parse(
    localStorage.getItem(COOKIE_ACCESS_SUBSCRIBED_COURSES) || "[]",
  );
  const updatedNavItems = updateNavItemsBySubscription(
    TNPSC_NAV_ICONS,
    subscribedCourses,
    examType,
    role,
  );

  const { logout } = useAuth();
  const logoutHandler = () => {
    logout();
    navigate("/", { replace: true });
  };

  const renderNavItems = (item, index) => {
    const { icon, route, label, smallIcon, disabled } = item || {};

    const isActive = route && location.pathname === route;

    return (
      <section
        className={`nav_wrapper${isActive ? " active" : ""}${
          disabled ? " disabled" : ""
        }`}
        key={index}
        data-tooltip={label}
        onClick={() => {
          if (disabled) return;

          route && navigate(route);
        }}
      >
        <span className={`nav_icon${smallIcon ? " small" : ""}`}>
          <img src={icon} alt={label} />
        </span>

        <span className="nav_label">{label}</span>
      </section>
    );
  };

  return (
    <section className="base_container">
      <section
        className={`nav_container${isExpanded ? " expanded" : ""}`}
        onMouseEnter={() => setIsExpanded(true)}
        onMouseLeave={() => setIsExpanded(false)}
      >
        <section className="nav_top_section">
          <div className="nav_logo_wrapper">
            <img
              src={assets.ic_nav_logo}
              alt="ic_nav_logo"
              className="nav_logo_img"
            />
            <span className="nav_brand">ROVIAN</span>
          </div>
          {updatedNavItems?.map(renderNavItems)}
        </section>
        <section className="nav_bottom_section">
          <section
            className="nav_wrapper bottom_item"
            data-tooltip="Profile"
            onClick={() => navigate(ROUTE_PROFILE)}
          >
            <img
              src={assets.ic_profile_chat}
              className="profile_icon"
              alt="profile"
            />
            <section className="profile_meta">
              <span className="profile_name">
                {user?.data?.name || mail || "Profile"}
              </span>
              {role && <span className="profile_role">{role}</span>}
            </section>
          </section>
          <section
            className="nav_wrapper bottom_item"
            data-tooltip="Logout"
            onClick={() => setShow(true)}
          >
            <img src={assets.ic_logout} className="logout_icon" alt="logout" />
            <span className="nav_label">Logout</span>
          </section>
        </section>
      </section>
      <section className={`user_child_wrapper${isExpanded ? " expanded" : ""}`}>
        {children}
      </section>
      {show && (
        <LogoutPopup
          title="Logout"
          description="Are you sure you want to logout from your account?"
          btnText="Logout"
          onClose={() => setShow(!show)}
          onLogout={logoutHandler}
        />
      )}
    </section>
  );
};
